import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import LoginPage from "./pages/LoginPage";
import OtpVerificationPage from "./pages/OtpVeryfication/OtpVeryfication";
import DashBoardPage from "./pages/DashBoard";
import CreateCategoryPage from './pages/AmtcUser/CreateCategory/CreateCategory';
import EditCategoryPage from './pages/AmtcUser/EditCategory/EditCategory';
import CreateSubCategoryPage from './pages/AmtcUser/CreateSubCategory/CreateSubCategory';
import EditSubCategoryPage from './pages/AmtcUser/EditSubCategory';
import AddNewProductPage from './pages/AmtcUser/AddNewProductPage';
import UpdateProdStockDtlsPage from './pages/AmtcUser/UpdateProdStockDtls/UpdateProdStockDtls';
import CompProdStockListPage from './pages/AmtcUser/CompProdStockList/CompProdStockList';
import CompanyListPage from './pages/AmtcUser/CompanyList/CompanyList';
import CreateCompanyPage from './pages/AmtcUser/CreateCompany/CreateCompany';
import CompanyDetailsPage from './pages/AmtcUser/CompanyDetailsPage';
import EditCompanyPage from './pages/AmtcUser/EditCompany/EditCompany';
import CreateProjectPage from './pages/AmtcUser/CreateProject/CreateProject';
import EditProjectPage from './pages/AmtcUser/EditProject/EditProject';
import AddProdToCompCatalogPage from './pages/AmtcUser/AddProdToCompCatalog/AddProdToCompCatalog';
import AddProdToCompCatalog2Page from './pages/AmtcUser/AddProdToCompCatalog2';
import Layout from './components/Layout';
import MissingPage from './pages/MissingPage';
import { useAuthContext } from './context/AuthContext';
import LoadingScreen from './components/LoadingScreen';
import HomePage from './pages/HomePage/HomePage';
import RequireAuth from './components/RequireAuth';
import cs from './utils/Constants';
import AmtcProfilePage from './pages/AmtcUser/AmtcProfilePage';
import AmtcCatalogPg from './pages/AmtcUser/AmtcCatalogPg';
import AmtcSubCategoryPage from './pages/AmtcUser/AmtcSubCategoryPage';
import AmtcProductListPage from './pages/AmtcUser/AmtcProductListPage';
import AmtcProdInfoPg from './pages/AmtcUser/AmtcProdInfoPg';
import EditProductInfoPg from './pages/AmtcUser/EditProductInfoPg';
import ComSubCategoryPage from './pages/AmtcUser/ComSubCategoryPage';
import ComProductListPage from './pages/AmtcUser/ComProductListPage';
import UpdateAgreeDetailsPg from './pages/AmtcUser/UpdateAgreeDetailsPg';
import ProdApprWaitPg from './pages/AmtcUser/ProdApprFlow/ProdApprWaitPg';
import ProdApprCreatePg from './pages/AmtcUser/ProdApprFlow/ProdApprCreatePg';
import CreateComEmpPage from './pages/AmtcUser/CreateComEmpPage';
import ComUserProfilePage from './pages/AmtcUser/ComUserProfilePage';
import EditComEmpPage from './pages/AmtcUser/EditComEmpPage';
import ProjInfoPage from './pages/AmtcUser/ProjInfoPage';
import DeptEmpListPage from './pages/AmtcUser/DeptEmpListPage';
import AmtcEmpListPage from './pages/AmtcUser/AmtcEmpListPage';
import CreateAmtcEmpPage from './pages/AmtcUser/CreateAmtcEmpPage';
import AssignSourceEmpPage from './pages/AmtcUser/AssignSourceEmpPage';
import EditAmtcEmpPage from './pages/AmtcUser/EditAmtcEmpPage';
import ComProdInfoPg from './pages/ComUser/ComProdInfoPg';
import ComCatList from './pages/AmtcUser/CompanyDetailsPage/ComCatList';
import CreateProdReqPage from './pages/ComUser/CreateProdReqPage';
import ProdReqListPage from './pages/ComUser/ProdReqListPage';
import ProdReqInfoPage from './pages/ComUser/ProdReqInfoPage';
import EditProdReqPage from './pages/ComUser/EditProdReqPage';
import NewProdReqListPage from './pages/ComUser/NewProdReqListPage';
import CreateNewProdReqPage from './pages/ComUser/CreateNewProdReqPage';
import NewProdReqInfoPage from './pages/ComUser/NewProdReqInfoPage';
import EditNewProdReqPage from './pages/ComUser/EditNewProdReqPage';
import ProjList from './pages/AmtcUser/CompanyDetailsPage/ProjList';
import CreateDeptPage from './pages/ComUser/CreateDeptPage/index.';
import ComEmp from './pages/AmtcUser/CompanyDetailsPage/ComEmp';
import CreateDeptEmpPage from './pages/ComUser/CreateDeptEmpPage';
import PoListPage from './pages/ComUser/PoListPage';
import PoInfoPage from './pages/ComUser/PoInfoPage';
import StorePoListPage from './pages/ComUser/StorePoListPage';
import StorePoInfoPage from './pages/ComUser/StorePoInfoPage';
import DoInfoPage from './pages/ComUser/DoInfoPage';
import CreateDoPage from './pages/AmtcUser/CreateDoPage';
import EditDoInvPage from './pages/AmtcUser/EditDoInvPage';
import PoTrackingList from './pages/ComUser/PoTrackingList/PoTrackingList';
import EditPoProdTrackDetails from './pages/AmtcUser/EditPoProdTrackDetails';
import PoLinkPage from './pages/PoLinkPage/PoLinkPage';
import ArchiveProds from './pages/AmtcUser/ArchiveProds';
import EditPotPage from './pages/AmtcUser/EditPotPage';
import EditPotInvPage from './pages/AmtcUser/EditPotInvPage';
import PrLinkPage from './pages/PrLinkPage/PrLinkPage';
import NprLinkPage from './pages/NprLinkPage/NprLinkPage';
import AddPotPage from './pages/AmtcUser/AddPotPage';

const theme = createTheme({
  palette: {
    navbar: {
      navbar: "rgba(162, 214, 249, 1)",
    },
    primary: {
      button: "rgba(255, 207, 48, 1)",
      main: "rgba(162, 214, 249, 1)",
      sub: "rgba(236, 246, 219, 0.7)",
    },
    secondary: {
      main: "rgba(0, 0, 0, 0.3)",/*light grey*/
      sub: " rgba(0, 0, 0, 0.5)",/*Dark Grey*/
    },
    action: {
      hover: "rgba(162, 214, 249, 0.4)"
    },
    otherColors: {
      txtFieldColor: "black",
      btn: "rgb(73, 177, 247, 1)",
    },
    custom: {
      main: "rgba(73, 177, 247, 1)",
      sub: "rgba(0, 0, 0, 0.3)",
      btn: "rgba(43, 137, 252, 1)",
      yBtn: "rgba(255, 183, 3, 1)",
      grey: "rgba(224, 224, 224, 1)",
      black: "rgba(0, 0, 0, 1)"
    },
  },
  typography: {
    fontFamily: [
      "Poppins", "Arial", "sans-serif",
    ].join(','),
    button: {
      textTransform: 'none'
    }
  },
})

function App() {
  const { loading } = useAuthContext();
  return (
    <ThemeProvider theme={theme}>
      {loading && <LoadingScreen />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/otpverification" element={<OtpVerificationPage />} />
        <Route path="/po/:poId" element={<PoLinkPage />} />
        <Route path="/pr/:prodReqIdStrg" element={<PrLinkPage />} />
        <Route path="/npr/:newProdReqIdStrg" element={<NprLinkPage />} />
        <Route path="/c" element={<Layout />}>
          <Route element={<RequireAuth allowedRoles={[cs.requestor, cs.approver]} />}>
            <Route path="cart" element={<CreateProdReqPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.focalPoint, cs.lineManager]} />}>
            <Route path="polist" element={<PoListPage type='com' />} />
            <Route path="po/info" element={<PoInfoPage type='com' />} />
            <Route path="do/info" element={<DoInfoPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.approver, cs.focalPoint, cs.lineManager]} />}>
            <Route path="po/tracking" element={<PoTrackingList type='com' />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.focalPoint]} />}>
            <Route path="projectList" element={<ProjList type='com' />} />
            <Route path="projectinfo" element={<ProjInfoPage type='com' />} />
            <Route path="dept/emplist" element={<DeptEmpListPage type='com' />} />
            <Route path="dept/create" element={<CreateDeptPage />} />
            <Route path="project/emplist" element={<ComEmp type='com' />} />
            <Route path="emp/create" element={<CreateDeptEmpPage />} />
            <Route path="emp/edit" element={<EditComEmpPage type='dept' />} />
            <Route path="user/profile" element={<ComUserProfilePage type='user' />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.requestor, cs.approver, cs.focalPoint, cs.lineManager]} />}>
            <Route path="dashboard" element={<DashBoardPage />} />
            <Route path="productInfo" element={<ComProdInfoPg />} />
            <Route path="myprofile" element={<ComUserProfilePage />} />
            <Route path="catalogue" element={<ComCatList type='com' />} />
            <Route path="subcategory" element={<ComSubCategoryPage type='com' />} />
            <Route path="products" element={<ComProductListPage type='com' />} />
            <Route path="prodreqlist" element={<ProdReqListPage />} />
            <Route path="prodreqinfo" element={<ProdReqInfoPage type='com' />} />
            <Route path="prodreq/edit" element={<EditProdReqPage />} />
            <Route path="newprodreqlist" element={<NewProdReqListPage />} />
            <Route path="newprodreqlist/create" element={<CreateNewProdReqPage />} />
            <Route path="newprodreqinfo" element={<NewProdReqInfoPage />} />
            <Route path="newprodreq/edit" element={<EditNewProdReqPage />} />
          </Route>
        </Route>


        <Route path="/a" element={<Layout />}>
          <Route element={<RequireAuth allowedRoles={[cs.admin, cs.sourcing, cs.store, cs.accounts]} />}>
            <Route path="profile" element={<AmtcProfilePage />} />
            <Route path="catalogue" element={<AmtcCatalogPg />} />
            <Route path="subcategory" element={<AmtcSubCategoryPage />} />
            <Route path="products" element={<AmtcProductListPage />} />
            <Route path="product" element={<AmtcProdInfoPg />} />
            <Route path="do/info" element={<DoInfoPage />} />
            <Route path="pot/edit" element={<EditPotPage />} />
            <Route path="sel/com" element={<CompanyListPage type='selCom' />} />
            <Route path="po/tracking" element={<PoTrackingList />} />
            <Route path="po/editpoprod" element={<EditPoProdTrackDetails />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.admin, cs.sourcing, cs.accounts]} />}>
            <Route path="polist" element={<PoListPage />} />
            <Route path="po/info" element={<PoInfoPage />} />

          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.admin, cs.sourcing, cs.store]} />}>
            <Route path="dashboard" element={<DashBoardPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.accounts, cs.admin]} />}>
            <Route path="do/editinv" element={<EditDoInvPage />} />
            <Route path="pot/editinv" element={<EditPotInvPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.store]} />}>
            <Route path="s/polist" element={<StorePoListPage />} />
            <Route path="s/po/info" element={<StorePoInfoPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.store, cs.admin]} />}>
            <Route path="s/do/create" element={<CreateDoPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.admin, cs.sourcing]} />}>
            <Route path="prod/stocklist" element={<CompProdStockListPage />} />
            <Route path="com/productInfo" element={<AmtcProdInfoPg type='com' />} />
            <Route path="companies" element={<CompanyListPage />} />
            <Route path="company" element={<CompanyDetailsPage />} />
            <Route path="com/projectinfo" element={<ProjInfoPage />} />
            <Route path="com/userprofile" element={<ComUserProfilePage type='user' />} />
            <Route path="dept/emplist" element={<DeptEmpListPage />} />
            <Route path="com/subcategory" element={<ComSubCategoryPage />} />
            <Route path="com/products" element={<ComProductListPage />} />
            <Route path="prodreqinfo" element={<ProdReqInfoPage />} />
            <Route path="newprodreqlist" element={<NewProdReqListPage />} />
            <Route path="newprodreqinfo" element={<NewProdReqInfoPage />} />            
            <Route path="pomanual-entry" element={<AddPotPage />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[cs.admin]} />}>
            <Route path="createcategory" element={<CreateCategoryPage />} />
            <Route path="editcategory" element={<EditCategoryPage />} />
            <Route path="createsubcategory" element={<CreateSubCategoryPage />} />
            <Route path="editsubcategory" element={<EditSubCategoryPage />} />
            <Route path="addproduct" element={<AddNewProductPage />} />
            <Route path="editproduct" element={<EditProductInfoPg />} />
            <Route path="prod/updatestock" element={<UpdateProdStockDtlsPage />} />
            <Route path="createcompany" element={<CreateCompanyPage />} />
            <Route path="editcompany" element={<EditCompanyPage />} />
            <Route path="createproject" element={<CreateProjectPage />} />
            <Route path="addprodtocatalog" element={<AddProdToCompCatalogPage />} />
            <Route path="addprodtocatalog/details" element={<AddProdToCompCatalog2Page />} />
            <Route path="prod/updateagreedtls" element={<UpdateAgreeDetailsPg />} />
            <Route path="prodapprlist" element={<ProdApprWaitPg />} />
            <Route path="prodapprcreatelist" element={<ProdApprCreatePg />} />
            <Route path="appr/waiting/productInfo" element={<AmtcProdInfoPg type='req' />} />
            <Route path="appr/created/productInfo" element={<AmtcProdInfoPg type='created' />} />
            <Route path="appr/editProduct" element={<EditProductInfoPg type='all' />} />
            <Route path="com/createemp" element={<CreateComEmpPage />} />
            <Route path="com/editemp" element={<EditComEmpPage />} />
            <Route path="editproject" element={<EditProjectPage />} />
            <Route path="amtc/emplist" element={<AmtcEmpListPage />} />
            <Route path="amtc/createemp" element={<CreateAmtcEmpPage />} />
            <Route path="amtc/empinfo" element={<AmtcProfilePage type='user' />} />
            <Route path="assign/sourceemp" element={<AssignSourceEmpPage />} />
            <Route path="amtc/editemp" element={<EditAmtcEmpPage />} />
            <Route path="amtc/editemp" element={<EditAmtcEmpPage />} />
            <Route path="archiveprods" element={<ArchiveProds />} />
          </Route>
        </Route>
        {/* catch all */}
        <Route path="*" element={<MissingPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;